import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  signal,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { SelectButtonModule } from 'primeng/selectbutton';
import { TooltipModule } from 'primeng/tooltip';
import { DirectivesModule } from 'src/app/directives/directives.module';
import { LanguageKey } from 'src/main/translate/language-key/language-key';

@Component({
  selector: 'app-color-selector',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    SelectButtonModule,
    TooltipModule,
    DirectivesModule,
  ],
  templateUrl: './color-selector.component.html',
  styleUrls: ['./color-selector.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ColorSelectorComponent implements OnInit, OnChanges {
  @Input() initialColor?: string;
  @Input() buttonName?: string;
  @Output() colorChange = new EventEmitter<string>();
  public languageKey = LanguageKey;

  public colors = signal([
    { name: 'Blue', hex: '#3b82f6' },
    { name: 'Green', hex: '#10b981' },
    { name: 'Yellow', hex: '#f59e0b' },
    { name: 'Cyan', hex: '#06b6d4' },
    { name: 'Pink', hex: '#ec4899' },
    { name: 'Indigo', hex: '#6366f1' },
    { name: 'Teal', hex: '#14b8a6' },
    { name: 'Orange', hex: '#f97316' },
    { name: 'Purple', hex: '#a855f7' },
    { name: 'Red', hex: '#ef4444' },
    { name: 'Slate', hex: '#64748b' },
    { name: 'Lime', hex: '#84cc16' },
    { name: 'Emerald', hex: '#059669' },
    { name: 'Amber', hex: '#d97706' },
    { name: 'Rose', hex: '#f43f5e' },
    { name: 'Violet', hex: '#8b5ed6' },
  ]); //TODO, resolver cores troca de tema

  public selectedColor = signal<any>(null);

  ngOnInit() {
    this.updateSelection();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['initialColor']) {
      this.updateSelection();
    }
  }

  private updateSelection() {
    if (!this.initialColor) {
      const first = this.colors()[0];
      this.selectedColor.set(first);
      this.colorChange.emit(first.hex);
      return;
    }

    const colorObj = this.colors().find(
      (c) => c.hex.toLowerCase() === this.initialColor?.toLowerCase(),
    );

    if (colorObj) {
      this.selectedColor.set(colorObj);
    }
  }

  onSelect(event: any) {
    if (event.value) {
      this.colorChange.emit(event.value.hex);
    } else {
      this.updateSelection();
    }
  }
}
